import SessionClientDashboard from 'dashboard/lib/clients/SessionClientDashboard';
import { SortParams } from 'dashboard/lib/interfaces/SortParams';
import { Environment } from 'dashboard/models/environment';
import { ExporterFileType, ExporterInquiry } from 'dashboard/models/exporter';
import { Inquiry } from 'dashboard/models/inquiry';
import { InquiriesFilterParams, saveInquiries } from 'dashboard/redux/actions/inquiries';
import { DashboardThunkAction } from 'dashboard/redux/types';
import EventsClient from 'lib/clients/EventsClient';
import { ApiEndpoint, ApiModel, PaginationParams } from 'lib/interfaces/api';

export const loadExporterInquiry =
  ({
    currentEnvironment,
    filters,
    sortParams,
    fileType,
  }: {
    currentEnvironment: Environment;
    filters: InquiriesFilterParams;
    sortParams: SortParams;
    fileType: ExporterFileType;
  }) =>
  async () => {
    const params = createParamsForList(currentEnvironment, filters, sortParams, fileType);

    await SessionClientDashboard.postResourceCreate<ExporterInquiry>({
      type: ApiModel.ExporterInquiry,
      attributes: {
        ...params,
      },
    });
  };

export function loadInquiryList({
  currentEnvironment,
  currentPage,
  pageSize,
  filters,
  sortParams,
  abortSignal,
}: {
  currentEnvironment: Environment;
  currentPage: number;
  pageSize: number;
  filters: InquiriesFilterParams;
  sortParams: SortParams;
  abortSignal?: AbortSignal;
}): DashboardThunkAction<Promise<void>> {
  return async (dispatch) => {
    const params = createParamsForList(currentEnvironment, filters, sortParams);

    const paramsFull = {
      ...params,
      page: {
        number: currentPage,
        size: pageSize,
      },
      signal: abortSignal,
    } as any;

    const inquiriesResponse = await SessionClientDashboard.listResource<Inquiry, PaginationParams>(
      ApiEndpoint.Inquiry,
      paramsFull,
    );

    const inquiries = inquiriesResponse.data;
    const paginationParams = inquiriesResponse.meta;

    dispatch(saveInquiries(inquiries, currentEnvironment, paginationParams));
  };
}

export function createParamsForList(
  currentEnvironment: Environment,
  inquiryFilters: InquiriesFilterParams,
  inquirySortParams: SortParams,
  /* @ts-expect-error [strict-migration] The following line is not strict; please fix! */
  fileType: ExporterFileType = null,
) {
  const {
    createdAtStart,
    createdAtEnd,
    status,
    templateIds,
    tagIds,
    tagsConditions,
    listIds,
    omni,
    checks,
    reusablePersonaUsed,
  } = inquiryFilters;
  const { sort, shouldSortDescending } = inquirySortParams;

  const params = {
    'file-type': fileType,
    filter: {
      'environment-id': currentEnvironment.id,
      status,
      'template-ids': templateIds,
      'tag-ids': tagIds,
      'tags-conditions': tagsConditions,
      'list-ids': listIds,
      omni,
      checks,
      'created-at-start': createdAtStart && createdAtStart.toString(),
      'created-at-end': createdAtEnd && createdAtEnd.toString(),
      'reusable-persona-used': reusablePersonaUsed,
    },
    // We want to keep omnisearch relevance ordering, instead of sorting
    sort: omni ? '' : `${shouldSortDescending ? '-' : ''}${sort}`,
  };

  EventsClient.logAmplitude('dashboard-ui__inquiry-filters.submit', params);

  return params;
}
